import { Any, JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('Value')
export class Value {
  @JsonProperty('_id')
  public id = '';

  @JsonProperty('name')
  public name = '';

  @JsonProperty('value', Any, true)
  public value?: any = undefined;

  @JsonProperty('from_secret')
  public fromSecret = false;

  @JsonProperty('last_modified', Number, true)
  public lastModified?: number = undefined;

  constructor(partial?: Partial<Value>) {
    Object.assign(this, partial);
  }
}

@JsonObject('PartialValue')
export class PartialValue {
  @JsonProperty('_id')
  public id = '';

  @JsonProperty('name')
  public name = '';

  @JsonProperty('from_secret')
  public fromSecret = false;

  @JsonProperty('last_modified', Number, true)
  public lastModified?: number = undefined;

  constructor(partial?: Partial<PartialValue>) {
    Object.assign(this, partial);
  }
}
